import { camelCase } from "lodash-es";

export const INVEST_TARGET_YEAR = {
  dataAid: "chooseTargetYear",
  header: {
    dataAid: (dataAid = "") => camelCase(`saveFor ${dataAid}`),
  },
  input: {
    dataAid: "targetYear",
    label: "Select a target year",
  },
  cta: {
    dataAid: "primary",
    title: "next",
  },
  bottomSheet: {
    dataAid: "bottomsheetChooseYear",
    title: "Select a year",
    cta: {
      dataAid: "primary",
      title: "confirm",
    },
  },
};

export default INVEST_TARGET_YEAR;
